<template>
  <div>
    <b-card class="m-3" id="consulta-pca-header-Card" no-body header-tag="header">
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Consulta de Prestações de Contas Anuais
          <b-button class="float-right m-1" @click.stop to="/contas-anuais/entrega">
            <!---->
            <font-awesome-icon icon="plus" class="mr-3" />
            Enviar Prestação Anual
          </b-button>
        </h6>
      </template>
      <b-row>
        <b-col cols="12" md="4" offset-md="8" lg="3" offset-lg="9">
          <b-input-group size="md" class="my-2 pr-2">
            <b-form-input name="busca-pca-contas" id="filter-input" v-model="filter" type="search" placeholder="Pesquisar"
              autocomplete="off"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table :busy="isBusy" :fields="fields" :filter="filter" :filter-included-fields="filterOn" hover
        no-border-collapse :items="items" :sticky-header="maxTableHeight" sort-by="IdPrestacaoConta" :sort-desc="true"
        striped show-empty stacked="md">
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="actions-icons">
            <div class="wrapper-icon" @click="openModalSignature(row.item)"
              v-if="row.item.Situacao === 'Aguardando Assinatura'">
              <font-awesome-icon icon="file-signature" />
              <div style="font-size: 12px">Assinatura</div>
            </div>
            <BtnDownload v-if="row.item.Situacao === 'Processada'" :key="row.item.IdPrestacaoConta"
              :fazerDownload="getRecibo" texto="Recibo" icone="receipt" :parametros="row.item.IdPrestacaoConta" />
            <div class="wrapper-icon" @click="viewDetail(row.item.IdPrestacaoConta)">
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Detalhes</div>
            </div>
          </div>
        </template>
      </b-table>
    </b-card>
    <router-view></router-view>
    <modal-pdf v-if="exibirModalPdf" @fecharModal="exibirModalPdf = false" :pdfData="pdfData" filename="recibo-pca" />
  </div>
</template>

<script>
import pcaService from "@/services/entregas/pcaService";
import BtnDownload from "@/components/shared/btn-download";
import ModalPdf from "@/components/ModalPdf"
import reportService from "@/services/reportService";
import { UtilsTS } from '@/utilsts';

export default {
  name: "ConsultaPCAComponent",
  components: { BtnDownload, ModalPdf },
  mixins: [UtilsTS],
  data() {
    return {
      filter: null,
      filterOn: ["IdPrestacaoConta", "DataEntrega", "Situacao", "Ano"],
      maxTableHeight: "600px",
      isBusy: true,
      fields: [
        {
          key: "IdPrestacaoConta",
          label: "ID",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "DataEntrega",
          label: "Início da entrega",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Situacao",
          label: "Situação",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Ano",
          label: "Ano",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
          sortable: false,
        },
      ],
      items: [],

      pdfData: null,
      exibirModalPdf: false,
    };
  },
  methods: {
    async getRecibo(id) {
      this.exibirModalPdf = false
      this.pdfData = null
      try {
        const response = await reportService.getReciboPca(id);
        const blob = this.base64ToPdf(response.ArquivoPdf)
        this.pdfData = URL.createObjectURL(blob)
        this.exibirModalPdf = true;
      } catch (e) {
        this.tratarError(e);
      }
    },
    viewDetail(IdPrestacaoConta) {
      this.$router.push("/contas-anuais/entrega/" + IdPrestacaoConta);
    },
    openModalSignature(item) {
      this.currentItem = item;
      this.$router.push(
        "/contas-anuais/consulta/assinatura/" + item.IdPrestacaoConta
      );
    },
    // carrega a lista de PCAs desta UG
    async loadData() {
      const response = await pcaService.listarPCAs();
      if (response && response.status == 200) {
        this.updateData(response.data);
      } else {
        if (response && response.status === 404) {
          this.$toast.error(
            "Erro ao obter a lista de prestações de contas. O sistema parece estar offline. Tente novamente em alguns minutos"
          );
        } else if (response && response.data && response.data.msg) {
          this.$toast.error(response.data.msg);
        } else {
          this.$toast.error("Erro ao obter a lista de prestações de contas");
        }
      }
      this.isBusy = false;
    },
    //atualiza tudo o que for necessário quando chega uma lista de PCAs
    updateData(data) {
      this.items = data
        .map((d) => {
          d.DataEntrega = this.formatData(d.DataEntrega);
          d.Situacao = this.formatSituacao(d.Situacao);
          return d;
        })
        .sort(this.$parent.sortByYear);
    },
    formatSituacao(sit) {
      switch (sit) {
        case "C":
          return "Cancelada";
        case "A":
          return "Aguardando Assinatura";
        case "R":
          return "Pronta para Assinar";
        case "P":
          return "Processada";
        case "M":
          return "Em andamento";
        case "I":
          return "Inconsistente";
        case "L":
          return "Liberado Reenvio";
        default:
          return sit;
      }
    },
    setMaxTableHeight() {
      this.maxTableHeight =
        window.innerHeight -
        (this.getAbsoluteHeight(".up-data") +
          this.getAbsoluteHeight(".headerwrapper")) -
        10 +
        "px";
    },
  },
  async mounted() {
    this.$nextTick(() => {
      this.setMaxTableHeight();
    });
    window.addEventListener("resize", this.setMaxTableHeight);
    await this.loadData();
  },
};
</script>

<style scoped>
.col-actions {
  padding: 0.5 0.15rem !important;
}

.wrapper-icon:hover {
  color: rgb(106, 106, 161);
  cursor: pointer;
}
</style>
